export default class Tmov {
  static get idEmpresa() {
    return 1;
  }

  static get razaoSocial() {
    return 'SOTRAN S/A LOGÍSTICA E TRANSPORTE';
  }
}
